module.exports = __webpack_public_path__ + "static/img/banner_img1.88ba8c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_img1.png
// module id = FIs6
// module chunks = 5